export default __webpack_public_path__ + "static/media/warning--added-lane-right--g1.d5032345.png";